import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0c95c55"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = { class: "breadcrumb-item active" }
const _hoisted_6 = { "aria-current": "location" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = {
  key: 0,
  class: "card-body d-flex flex-column"
}
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_15 = { class: "badge bg-primary me-1" }
const _hoisted_16 = { class: "text-muted" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_18 = { class: "flex-fill" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_20 = {
  key: 1,
  class: "card-body"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = {
  key: 0,
  class: "col-3 w-20"
}
const _hoisted_24 = { class: "card" }
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-0" }, "Manage ticket", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_28 = {
  key: 0,
  class: "btn-group"
}
const _hoisted_29 = { class: "btn btn-primary dropdown-toggle dropdown-toggle-split" }
const _hoisted_30 = { class: "dropdown-menu" }
const _hoisted_31 = { class: "card mt-5" }
const _hoisted_32 = { class: "card-body" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_user_link = _resolveComponent("user-link")
  const _component_time_ago = _resolveComponent("time-ago")
  const _component_icon = _resolveComponent("icon")
  const _directive_tooltip = _resolveDirective("tooltip")
  const _directive_dropdown = _resolveDirective("dropdown")

  return ($setup.ticket)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["MetaTag"], {
          name: "og:title",
          content: $setup.ticket.title
        }, null, 8, ["content"]),
        _createVNode($setup["MetaTag"], {
          name: "og:url",
          content: $setup.endpoints.main(`/view/${$setup.ticket.id}`)
        }, null, 8, ["content"]),
        _createVNode($setup["MetaTag"], {
          names: ['og:description', 'description'],
          content: $setup.stub($setup.ticket.renderedbody)
        }, null, 8, ["content"]),
        _createVNode($setup["FeedTag"], {
          "object-id": $setup.ticket.id
        }, null, 8, ["object-id"]),
        _createVNode($setup["TitleTag"], {
          title: $setup.ticket.title
        }, null, 8, ["title"]),
        _createElementVNode("ol", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_router_link, { to: "/tracker" }, {
              default: _withCtx(() => [
                _createTextVNode("Trackers")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: '/tracker/' + $setup.ticket.product.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.ticket.product.prettyName), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString($setup.ticket.title), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (!$setup.editing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createVNode($setup["Status"], {
                        class: "float-end mb-2",
                        ticket: $setup.ticket
                      }, null, 8, ["ticket"]),
                      _createElementVNode("h1", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, "#" + _toDisplayString($setup.ticket.number), 1),
                        _createTextVNode(" " + _toDisplayString($setup.ticket.title), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ticket.tags, (tag) => {
                          return (_openBlock(), _createBlock($setup["Tag"], {
                            class: _normalizeClass(["me-1", {pointer: $setup.canSetTags}]),
                            tag: tag,
                            onClick: $event => ($setup.removeTag(tag.name))
                          }, {
                            default: _withCtx(() => [
                              ($setup.canSetTags)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "×"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["tag", "class", "onClick"]))
                        }), 256))
                      ]),
                      _createElementVNode("span", _hoisted_15, _toDisplayString($setup.ticket.product.prettyName), 1),
                      _createVNode($setup["Kind"], {
                        class: "me-2",
                        kind: $setup.ticket.kind
                      }, null, 8, ["kind"]),
                      _createElementVNode("span", _hoisted_16, [
                        _createTextVNode("by "),
                        _createVNode(_component_user_link, {
                          user: $setup.ticket.author
                        }, null, 8, ["user"]),
                        _createVNode(_component_time_ago, {
                          time: $setup.ticket.createdAt
                        }, null, 8, ["time"])
                      ]),
                      ($setup.canEdit)
                        ? _withDirectives((_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn float-end",
                            onClick: $setup.startEdit
                          }, [
                            _createVNode(_component_icon, {
                              class: "text-muted",
                              icon: "edit"
                            })
                          ])), [
                            [_directive_tooltip, 'Edit ticket']
                          ])
                        : _createCommentVNode("", true),
                      _hoisted_17
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode($setup["Markdown"], {
                        html: $setup.ticket.renderedbody
                      }, null, 8, ["html"])
                    ]),
                    _hoisted_19,
                    _createVNode($setup["BottomSocials"], {
                      "object-id": $setup.ticket.id,
                      rating: $setup.ticket.rating,
                      "show-share-url": false
                    }, null, 8, ["object-id", "rating"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("h5", null, "Editing ticket #" + _toDisplayString($setup.ticket.number), 1),
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.newTitle) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.newTitle]
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-danger",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = $event => ($setup.editing = false))
                      }, "Cancel"),
                      _createElementVNode("button", {
                        class: "btn btn-success",
                        type: "button",
                        onClick: $setup.submitEdit
                      }, "Save")
                    ]),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control mt-3",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.newBody) = $event)),
                      rows: "10"
                    }, null, 512), [
                      [_vModelText, $setup.newBody]
                    ])
                  ]))
            ])
          ]),
          ($setup.canSetStatus || $setup.canSetTags)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _hoisted_27,
                    ($setup.canSetStatus)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          ($setup.ticket.isOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("button", {
                                  class: "btn btn-primary",
                                  onClick: _cache[3] || (_cache[3] = $event => ($setup.setClosed(true)))
                                }, "Close ticket"),
                                _withDirectives(_createElementVNode("button", _hoisted_29, null, 512), [
                                  [_directive_dropdown]
                                ]),
                                _createElementVNode("ul", _hoisted_30, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _cache[4] || (_cache[4] = _withModifiers($event => ($setup.closeInVersion()), ["prevent"]))
                                    }, "Close in version")
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-primary",
                                onClick: _cache[5] || (_cache[5] = $event => ($setup.setClosed(false)))
                              }, "Reopen ticket"))
                        ], 64))
                      : _createCommentVNode("", true),
                    ($setup.canSetTags)
                      ? (_openBlock(), _createBlock($setup["TagPicker"], {
                          key: 1,
                          class: "mt-3",
                          ticket: $setup.ticket
                        }, null, 8, ["ticket"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode($setup["CommentList"], {
              objectid: $setup.ticket.id
            }, null, 8, ["objectid"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}